<template>
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect x="6" y="3" width="4" height="18" rx="2" fill="currentColor" />
    <rect x="14" y="3" width="4" height="18" rx="2" fill="currentColor" />
  </svg>
</template>